import { Box, SkeletonCircle, SkeletonText, Stack, Text } from '@chakra-ui/react'
import { range } from 'lodash-es'

import type { RealtimeConversationsListSubscription } from '@/client/services/hasura/generated/graphql'

import ConversationListItem, { type ConversationListItemProps } from './ConversationListItem'

const SKELETON_COUNT = 10
export default function ConversationList({
  activeConversationUuid,
  conversations,
  loading,
  onListItemClick,
}: {
  activeConversationUuid?: string | null
  conversations: RealtimeConversationsListSubscription['conversation'] | null
  loading: boolean
  onListItemClick: ConversationListItemProps['onClick']
}): React.ReactElement {
  return (
    <Stack direction="column" spacing="8px">
      {loading || conversations == null ? (
        <Stack direction="column" spacing="16px">
          {range(SKELETON_COUNT).map(i => (
            <Stack
              key={i}
              borderBottom="2px solid"
              borderColor="border.muted"
              cursor="pointer"
              color="fg"
              textDecoration="none"
              as="a"
              px="24px"
              direction="row"
              spacing="16px"
              align="center"
              width="100%"
              height="100px"
            >
              <SkeletonCircle size="48px" />
              <SkeletonText noOfLines={2} skeletonHeight={2} flex={1} />
            </Stack>
          ))}
        </Stack>
      ) : conversations.length === 0 ? (
        <Box p="16px" textAlign="center">
          <Text>No conversations.</Text>
        </Box>
      ) : (
        <Stack direction="column" spacing="0px">
          {conversations.map(conversation => (
            <ConversationListItem
              key={`${conversation.external_uuid}`}
              conversation={conversation}
              isActive={activeConversationUuid === conversation.external_uuid}
              onClick={onListItemClick}
            />
          ))}
        </Stack>
      )}
    </Stack>
  )
}
